var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.computedClass },
    [
      _c(
        "JadeLabel",
        {
          attrs: {
            optional: _vm.optional,
            error: _vm.error,
            disabled: _vm.disabled,
            hidden: _vm.hideLabel,
            htmlFor: _vm.label,
          },
        },
        [_vm._v(" " + _vm._s(_vm.label) + " ")]
      ),
      _c(
        "div",
        { class: _vm.computedContentClass },
        [
          _vm.leadingItem
            ? _c(
                "div",
                { staticClass: "jade-input-field__content__leading-item" },
                [
                  _vm.isIconAdornment(_vm.leadingItem)
                    ? _c("JadeIcon", {
                        attrs: {
                          size: "medium",
                          color: "current-color",
                          use: _vm.leadingItem?.content,
                        },
                      })
                    : _vm._e(),
                  _vm.isTextAdornment(_vm.leadingItem)
                    ? _c(
                        "JadeText",
                        {
                          attrs: {
                            variant: "text-medium",
                            weight: "regular",
                            color: "current-color",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.leadingItem?.content) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            _vm.as,
            _vm._b(
              {
                ref: "input",
                tag: "component",
                attrs: {
                  value: _vm.value,
                  id: _vm.id,
                  type: _vm.type,
                  disabled: _vm.disabled,
                  "aria-required": !_vm.optional,
                  "aria-label": _vm.label,
                  maxlength: _vm.maxlength,
                },
                on: {
                  input: ($event) => {
                    _vm.$emit("update:value", $event.target.value)
                    _vm.$emit("input", $event.target.value)
                  },
                },
              },
              "component",
              _vm.$attrs,
              false
            )
          ),
          _vm.isIconAdornment(_vm.trailingItem)
            ? _c(
                "div",
                { staticClass: "jade-input-field__content__trailing-item" },
                [
                  _vm.isIconButton
                    ? _c("JadeIconButton", {
                        attrs: {
                          size: "medium",
                          variant: "neutral-ghost",
                          icon: _vm.trailingItem.content,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("onTrailingItemClick")
                          },
                        },
                      })
                    : _c("JadeIcon", {
                        attrs: {
                          size: "medium",
                          color: "medium",
                          use: _vm.trailingItem.content,
                        },
                      }),
                ],
                1
              )
            : _vm._e(),
          _vm.isTextAdornment(_vm.trailingItem)
            ? _c(
                "JadeText",
                { attrs: { variant: "text-medium", color: "medium" } },
                [_vm._v(" " + _vm._s(_vm.trailingItem.content) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("JadeSupportText", { attrs: { error: _vm.error } }, [
        _vm._v(" " + _vm._s(_vm.supportText) + " "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }